import {
  ErrorDetailsDtoErrorCodeEnum,
  EditEmployeeRequest,
  ResponseErrorDto,
} from '@interfaces/models';
import { removeOnboardingImportedEmployee, editOnboardingImportedEmployee } from '@api/onboarding';
import { useMutation } from '@tanstack/react-query';

export const useOnboardingImportedEmployees = ({
  onRemoveEmployeeSuccess,
  onEditEmployeeSuccess,
  onRemoveEmployeeError,
  onEditEmployeeError,
}: {
  onRemoveEmployeeError?: (error: ErrorDetailsDtoErrorCodeEnum) => void;
  onEditEmployeeError?: (error: ErrorDetailsDtoErrorCodeEnum) => void;
  onRemoveEmployeeSuccess?: () => void;
  onEditEmployeeSuccess?: () => void;
}) => {
  const { mutate: removeEmployee, isPending: isRemoveEmployeePending } = useMutation({
    mutationFn: (employeeId: string) => removeOnboardingImportedEmployee(employeeId),
    onSuccess: () => {
      onRemoveEmployeeSuccess?.();
    },
    onError: ({ error }: { error: ResponseErrorDto }) => {
      onRemoveEmployeeError?.(error.errorCode as ErrorDetailsDtoErrorCodeEnum);
    },
  });

  const { mutate: editEmployee, isPending: isEditEmployeePending } = useMutation({
    mutationFn: (params: { employee: EditEmployeeRequest }) =>
      editOnboardingImportedEmployee(params.employee, params.employee.id),
    onSuccess: () => {
      onEditEmployeeSuccess?.();
    },
    onError: ({ error }: { error: ResponseErrorDto }) => {
      onEditEmployeeError?.(error.errorCode as ErrorDetailsDtoErrorCodeEnum);
    },
  });

  return { removeEmployee, editEmployee, isRemoveEmployeePending, isEditEmployeePending };
};
